module.exports = __webpack_public_path__ + "static/media/triangle_two.5876f8fe.png";